import { FieldNames } from "./document-fieldsets";
import { FieldSet, FieldSetValue } from "./use-fieldset";

/**
 * Helper function to lookup products from document fieldset
 * Returns array of product codes
 */
export function getProductsFromFieldset(fieldSet: FieldSet | undefined) {
  const productsFieldValue = fieldSet?.[FieldNames.Products];
  return getProductsFromFieldsetValue(productsFieldValue);
}

/**
 * Extract product codes from a fieldset value
 * Products is typically a string array from the API, but can also be a single string
 * Returns array of product codes (empty if none found)
 */
export function getProductsFromFieldsetValue(
  productsFieldValue: FieldSetValue | undefined
) {
  if (!productsFieldValue) {
    return [];
  }

  // Products is typically an array of strings
  if (Array.isArray(productsFieldValue)) {
    return productsFieldValue as string[];
  }

  // Products can also be a single string value
  if (typeof productsFieldValue === "string") {
    return [productsFieldValue];
  }

  return [];
}
